export enum TimeEndType {
  NEVER = 'never',
  DATE = 'date',
  COUNT = 'count',
}
